import { Link } from "react-router-dom";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-cotton-100 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-heading text-4xl font-bold text-primary mb-8">
          Terms & Conditions
        </h1>
        
        <div className="bg-white p-8 rounded-lg shadow-soft space-y-6">
          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">1. Introduction</h2>
            <p className="text-muted-foreground leading-relaxed">
              Welcome to OGAS (www.ogas.in). These terms and conditions govern your use of our website 
              and the purchase of products from our online store. By accessing our website and placing 
              orders, you agree to be bound by these terms.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">2. Company Information</h2>
            <p className="text-muted-foreground leading-relaxed">
              OGAS is a registered t-shirt manufacturing company based in Tirupur, Tamil Nadu, India. 
              We have been in the textile business for over 25 years, specializing in 100% cotton, 
              bio-washed t-shirts under our brands "U & Mi" (Men's) and "KiTees" (Boys).
            </p>
            <p className="text-muted-foreground leading-relaxed mt-2">
              <strong>Address:</strong> 25A, Padmavathipuram 1st Street, Gandhinagar Post, Tirupur - 641603, Tamil Nadu, India<br />
              <strong>Email:</strong> admin@ogas.in<br />
              <strong>Phone:</strong> +91 99947 93643
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">3. Products & Pricing</h2>
            <p className="text-muted-foreground leading-relaxed">
              All products displayed on our website are subject to availability. Prices are listed in 
              Indian Rupees (INR) and include applicable taxes. OGAS reserves the right to modify prices 
              without prior notice. The price at the time of order placement will be the final price.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">4. Orders & Payment</h2>
            <p className="text-muted-foreground leading-relaxed">
              Orders can be placed through our website. Payment can be made via Credit Card, Debit Card, 
              UPI, Net Banking, or Digital Wallets through our secure Razorpay payment gateway. 
              Order confirmation will be sent to your registered email address.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">5. Shipping & Delivery</h2>
            <p className="text-muted-foreground leading-relaxed">
              We ship across India. Standard delivery takes 5-7 business days. Shipping is FREE on all orders. 
              You will receive tracking information once your order is dispatched.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">6. Returns & Refunds</h2>
            <p className="text-muted-foreground leading-relaxed">
              We accept returns within 7 days of delivery for unused products in original packaging. 
              Refunds will be processed within 5-7 business days after receiving the returned item. 
              Please contact us at admin@ogas.in for return requests.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">7. Contact Us</h2>
            <p className="text-muted-foreground leading-relaxed">
              For any queries regarding these terms, please contact us at admin@ogas.in or call +91 99947 93643.
            </p>
          </section>
        </div>

        <div className="mt-8 text-center">
          <Link to="/" className="text-primary hover:underline">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
}
